import React, { useContext, useEffect, useState } from "react";
import { AppConfigContext } from "../context/AppConfigContext";
import QRCode from "react-qr-code";
import { MenuContext } from "../context/MenuContext";
import { ModalContext } from "../context/ModalContext";
import WhatsAppService from "../services/WhatsAppService";

const WhatsApp = () => {
  const { whatsapp_qrcode, whatsapp_status } = useContext(AppConfigContext);
  const { selectTabs, setSelected } = useContext(MenuContext);
  const { success, alert } = useContext(ModalContext);

  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    selectTabs();
    setSelected({ title: "WhatsApp" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const { data } = await WhatsAppService.sync();
      const s = data?.summary;
      success(
        s
          ? `Sincronización completa: ${s.created} creados, ${s.linked} vinculados, ${s.attachments} adjuntos, ${s.skipped} sin cambios.`
          : "Sincronización iniciada."
      );
    } catch (error) {
      const status = error?.response?.status;
      alert(
        status === 409
          ? "No se pudo sincronizar: el bot no está listo o ya hay una sincronización en curso."
          : "No se pudo sincronizar los mensajes de WhatsApp."
      );
    } finally {
      setSyncing(false);
    }
  };

  const renderQrCode = () => {
    if (
      whatsapp_status !== "connected" &&
      whatsapp_qrcode &&
      whatsapp_qrcode !== null
    ) {
      return <QRCode value={whatsapp_qrcode} />;
    }
  };

  const renderStatus = () => {
    if (whatsapp_status === "disconnected") {
      return (
        <div>
          <span className="badge badge-pill bg-danger">Desconectado</span>
          <p className="mt-2">
            Debes vincular tu dispositivo a Arqvisor Bot para continuar usando
            tus beneficios.
          </p>
          <p>
            Escanea el código QR usando WhatsApp desde tu dispositivo.
          </p>
          <a
            target="_blank"
            rel="noreferrer noopener"
            className="btn btn-outline-primary"
            href="https://faq.whatsapp.com/1317564962315842/?locale=es_LA&cms_platform=web"
          >
          <i className="fas fa-external-link-alt" />  Aprender más
          </a>
        </div>
      );
    }
    return (
      <span
        className={`badge d-inline mb-3 text-capitalize badge-pill ${
          whatsapp_status === "connected" ? "bg-success" : "bg-danger"
        }`}
      >
        {whatsapp_status}
      </span>
    );
  };

  return (
    <div className="container-fluid">
      <h1 className="h3 pb-2 mb-3 border-bottom">
        Conectar Arqvisor WhatsApp Bot
      </h1>
      <div className="row">
        <div className="col-12 col-md-8 col-xl-6">
          <div className="card p-3 shadow">
            <div className="row">
              <div className="col-6">
                <h2 className="h4">Estado del Bot</h2>
                {renderStatus()}
                {whatsapp_status === "connected" && (
                  <div className="mt-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={handleSync}
                      disabled={syncing}
                    >
                      <i className="fas fa-sync me-1" />
                      {syncing ? "Sincronizando..." : "Sincronizar mensajes"}
                    </button>
                    <p className="text-muted small mb-0 mt-2">
                      Recupera los mensajes recientes que no se hayan registrado
                      (por ejemplo tras reconectar el dispositivo).
                    </p>
                  </div>
                )}
              </div>
              <div className="col-6 text-center">{renderQrCode()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsApp;
